/**
 * Created by han on 1/11/2019.
 */

import $ from 'jquery';
import sameHeight from './height';
import jcf from './jcf';
import slick from './slick.min';
import './jcf.select';

window.$ = $;
window.jquery = $;
window.jQuery = $;

function Touch() {

    if ('ontouchstart' in document.documentElement) {

        $('.can-touch').on('touchstart touchend', function(e) {

        	let _ = $(this);

            _.toggleClass('over');
            let st = setTimeout(function() { _.toggleClass('over'); }, 500);
            clearTimeout(st);
        });
    }
}

const jcfInit = () => {
	jcf.setOptions('Select', {
		wrapNative: false,
		wrapNativeOnMobile: false,
		useCustomScroll: false,
	});

	jcf.replaceAll();
};

function ImgTobg() {
	$('.img-to-bg').each(function() {
		if ($(this).find('img').length) {
			$(this).css('background-image', 'url(' + $(this).find('> img').attr('src') + ')');
		}
	});
}
function visualSlider(){
	$('.slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		fade: true,
		speed: 2000,
		autoplaySpeed: 3000,
		autoplay: true,
	});
}
function visualSliderkoto(){
	$('.slider-koto').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		fade: true,
		speed: 2000,
		autoplaySpeed: 3000,
		autoplay: true,
	});
}
function tabs(){
	$('ul.tabs-caption').on('click', 'li:not(.active)', function() {
		$(this)
		.addClass('active').siblings().removeClass('active')
		.closest('div.tabs').find('div.tabs-content').removeClass('active').eq($(this).index()).addClass('active');
	});
}

function dropMenu(){

    var hoverBtn = $('.nav-main__drop, .has-drop');
    var btnMb = $('.drop-btn');
    var drop = $('.nav-main__drop');

	function toggle(e) {

		e.preventDefault();

		if ( window.innerWidth <= 991 ) {
            if (e.type === 'click') {

            	let drop = $(e.target).parent().next();
                if ( drop.attr('data-drop') === 'open' ) {
                    drop.attr('data-drop', 'close');
                } else if ( drop.attr('data-drop') === 'close' ) {
                    drop.attr('data-drop', 'open');
                }

            }
		} else {
            if (e.type === 'mouseover') {
                drop.attr('data-drop', 'open');
            } else if (e.type === 'mouseout') {
                drop.attr('data-drop', 'close');
            }
		}
	}

    hoverBtn.on('mouseover mouseout', toggle);
    btnMb.on('click', toggle);

    // $('.nav-main__drop, .has-drop').on('mouseover', function(event){
    //     drop.attr('data-drop', 'open');
    // }).mouseout(function(event){
    //     drop.attr('data-drop', 'close');
    // });
}

function imgTab() {
	$('[data-img-source]').on('mouseover', e => {
		const src = $(e.target).closest('a').children('img').attr('src');
		console.dir( src );
		if (src) {
			$('[data-img-general]').css('background-image', 'url(' + src + ')');
			$('[data-img-source]').find('a').removeClass('active');
			$(e.target).closest('a').addClass('active');
		}
	});
}

const Playground = function () {
    Touch();
    dropMenu();
	imgTab();
	jcfInit();
	ImgTobg();
	visualSlider();
	visualSliderkoto();
	tabs();
	sameHeight('.image-hi-ll', {
		rows: 4,
		breakpoints: {
			991: {
				rows: 2
			}
		}
	});
	sameHeight('[data-st-height]', {
		rows: 4,
		breakpoints: {
			768: {
				rows: 2
			}
		}
	});
    sameHeight('[data-st-height-rec]', {
        rows: 4,
        breakpoints: {
            768: {
                rows: 2
            }
        }
    });
	window.addEventListener('load', () => {
		sameHeight('.image-hi', {
			rows: 4,
			breakpoints: {
				991: {
					rows: 2
				}
			}
		});
	});
};

export default {
	name: 'Main',
	Main: Playground,
	on: {
		'interactive': function () {
			this.Main();
		}
	}
};